import ExtratoContaCorrenteList from '../../spa/conta-corrente/extrato/ExtratoContaCorrenteList';

export default {
  path: 'extrato-akzo',
  name: 'extrato-akzo',
  component: ExtratoContaCorrenteList,
};
